import React from 'react';
import { Link, Nav } from './styles';

export const NavBar = ({open, click}) => {
    return (
        <Nav open={open}>
            <Link onClick={click} to='/productos'>Productos</Link>
            <Link onClick={click} to='/nosotros'>Sobre Nosotros</Link>
            <Link onClick={click} to='/blog'>Blog</Link>
            <Link onClick={click} to='/preguntas'>Preguntas Frecuentes</Link>
        </Nav>
    )
}